import {Component} from '@angular/core';
import {FavouritesService} from '../../../services/favourites.service';
import {CommonService} from '../../../services/common.service';

@Component({
    selector: 'favourites-component',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class FavouritesComponent {
  public favourites;
  public loading: boolean;

  constructor(
    protected favouritesService: FavouritesService,
    public commonService: CommonService
  ) {
    this.loading = true;
    this.favouritesService
      .getUserListingFavourites()
      .then((data) => {
        this.favourites = data;
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
      });
  }
  public navigate(path) {
    this.commonService.navigate(path);
  }
}
